<template>
  <div id="deviceList">
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="12" md="12" lg="12" xl="10">
        <CRow>
          <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
            <label>Thao tác</label>
            <div class="dropdown btn-group" style="height: 36px;">
              <button class="btn">
                <div class="group-checkbox">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="actionData.model.selectedAll"
                      @change="changeSelectAll()"
                      id="selectedAll"
                    />
                    <label class="custom-control-label" for="selectedAll"></label>
                  </div>
                </div>
              </button>
              <button
                type="button"
                class="dropdown-toggle dropdown-toggle-split btn"
                data-toggle="dropdown"
                aria-expanded="false"
                aria-haspopup="true"
              ></button>
              <div class="dropdown-menu">
                <button
                  :disabled="actionData.model.listDeviceSelectedId.length === 0"
                  class="dropdown-item"
                  @click="setupSelectOneAction('action_list', null,null,null, typeActionList.STOP_BROADCASTING)"
                  color="danger">
                  <i class="fa fa-stop-circle mr-2" style="font-size: 1.1rem!important;"></i>
                  Dừng phát thanh
                </button>
                <button
                  :disabled="actionData.model.listDeviceSelectedId.length === 0"
                  class="dropdown-item"
                  @click="isShowModalChangeVolumeMultipleDevice = true"
                  color="danger">
                  <i class="fa fa-volume-up mr-2" style="font-size: 1rem!important;"></i>
                  Thay đổi âm lượng
                </button>
                <button v-if="$hasAuthor('ROLE_ADMIN')"
                        :disabled="actionData.model.listDeviceSelectedId.length === 0"
                        class="dropdown-item"
                        @click="setupSelectOneAction('action_list', null,null,null, typeActionList.GET_STATUS)"
                        color="danger">
                  <i class="fa fa-refresh mr-2" style="font-size: 1rem!important;"></i>
                  Đồng bộ dữ liệu
                </button>
                <button v-if="$hasAuthor('ROLE_ADMIN')"
                        :disabled="actionData.model.listDeviceSelectedId.length === 0"
                        class="dropdown-item"
                        @click="setupSelectOneAction('action_list', null,null,null, typeActionList.CHECK_TEMPERATURE)"
                        color="danger">
                  <i class="fa fa-thermometer-empty mr-2" style="font-size: 1rem!important;"></i>
                  Kiểm tra nhiệt độ
                </button>
                <button
                  :disabled="actionData.model.listDeviceSelectedId.length === 0"
                  class="dropdown-item"
                  @click="setupSelectOneAction('action_list', null,null,null, typeActionList.RESTART_LIST)"
                  color="danger">
                  <i class="fa fa-power-off mr-2" style="font-size: 1rem!important;"></i>
                  Khởi động lại thiết bị
                </button>
                <button v-if="$hasAuthor('ROLE_ADMIN')"
                        :disabled="actionData.model.listDeviceSelectedId.length === 0"
                        class="dropdown-item"
                        @click="setupSelectOneAction('action_list', null,null,null, typeActionList.DELETE_LIST)"
                        color="danger">
                  <CIcon name="cil-trash" class="mr-2"/>
                  Xóa thiết bị được chọn
                </button>
                <button v-if="$hasAuthor('ROLE_ADMIN')"
                        :disabled="actionData.model.listDeviceSelectedId.length === 0"
                        class="dropdown-item"
                        @click="setupSelectOneAction('action_list', null,null,null, typeActionList.UPDATE_APP_LIST)"
                        color="danger">
                  <i class="fa fa-download mr-2"/>
                  Cập nhật phần mềm thiết bị được chọn
                </button>
              </div>
            </div>
          </CCol>
          <!-- <CCol xs="12" sm="5" md="5" lg="5" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
            <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                        ref="districtCodeInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="5" md="5" lg="5" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
            <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
          </CCol> -->
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseSelect :options="connectStatusSelect.options" :data="connectStatusSelect.data"
                        ref="connectStatusSelect"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseSelect :options="activeStatusSelect.options" :data="activeStatusSelect.data"
                        ref="activeStatusSelect"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseInput
              :options="codeInput.options"
              :data="codeInput.data"
            />
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="3">
            <BaseInput
              :options="descriptionInput.options"
              :data="descriptionInput.data"
            />
          </CCol>
          <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN')">
            <BaseSelect :options="locationStatusSelect.options" :data="locationStatusSelect.data"
                        ref="locationStatusSelect"></BaseSelect>
          </CCol> -->
        </CRow>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="2">
        <CRow>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div style="margin-top: 10px">
                <CButton
                  style="float: right;margin-left: 5px;"
                  color="primary"
                  v-c-tooltip.hover="'Tải lại'"
                  class="btn-action-primary"
                  @click="loadDataMainTable(true)">
                  <i class="fa fa-refresh"></i>&nbsp;Tải lại
                </CButton>
                <!-- <CButton v-if="$hasAuthor('ROLE_ADMIN')"
                         style="float: right;margin-left: 5px;"
                         color="primary"
                         v-c-tooltip.hover="'Xem bản đồ'"
                         class="btn-action-primary"
                         @click="$router.push('/devices-management/map.html')">
                  <i class="fa fa-map-marker"></i>&nbsp; Xem bản đồ
                </CButton> -->
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          @row-click="rowClickTable($event)"
          ref="mainTable">
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listDeviceSelectedId"
                  :value="item.id"
                  :id="item.id"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #code="{item}">
            <td>
              <span :key="item.code" v-c-tooltip:hover="item.code" class="description">
                {{ item.code }}<br/>
              </span>
            </td>
          </template>
          <template #phoneNumber="{item}">
            <td>
              <template v-if="item.networkType === 0">
                <span v-if="item.ipAddress != null && item.ipAddress != ''">
                {{ item.ipAddress }}
                <i v-c-tooltip="'Sao chép'" class="fa fa-copy"
                   style="font-size: 17px;font-weight: 600;" @click="copyPhoneNumber(item.ipAddress)"></i>&nbsp;
                  </span>
                <span v-else class="badge badge-light">Chưa xác định </span>
              </template>
              <template v-else>
                  <span v-if="item.phoneNumber != null && item.phoneNumber != ''">
                      <span :key="item.phoneNumber"
                            v-c-tooltip:hover="{ content : getInformationPhone(item), placement: 'left' }">{{
                          item.phoneNumber
                        }} </span>
                      <i v-c-tooltip="'Sao chép'" class="fa fa-copy"
                         style="font-size: 17px;font-weight: 600;" @click="copyPhoneNumber(item.phoneNumber)"></i>&nbsp;
                      <template v-if="item.numberRemainingDaysUseData && item.numberRemainingDaysUseData <= 30">
                        <i class="fa"
                           :class="item.numberRemainingDaysUseData < 0 ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'"
                           style="font-size: 20px;"
                           :style="item.numberRemainingDaysUseData < 0 ? 'color:red' : 'color: #ff8502'"
                           :key="item.phoneNumber"
                           v-c-tooltip:hover="item.numberRemainingDaysUseData < 0 ? 'Đã hết hạn dữ liệu DATA' : `Dữ liệu DATA còn lại ${item.numberRemainingDaysUseData.toString()} ngày`"></i>
                      </template>
                      <br/>
                        <template v-if="item.connectStatus == 1">
                          <div id="bars">
                            <div class="bar"
                                 :style="item.phoneSignal >= 1 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'"></div>
                            <div class="bar"
                                 :style="item.phoneSignal >= 2 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'"></div>
                            <div class="bar"
                                 :style="item.phoneSignal >= 3 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'"></div>
                            <div class="bar"
                                 :style="item.phoneSignal >= 4 ? 'background: rgba(0,0,0,0.82)' : 'background: rgba(0,0,0,0.35)'"></div>
                          </div>
                          <span style="font-weight: 700;">{{ generatePhoneNetWork(item) }}</span>
                         </template>
                    </span>
                <span v-else class="badge badge-light">Chưa xác định </span>
              </template>
            </td>
          </template>
          <template #volume="{item}">
            <td class="volume">
              <CDropdown
                color="p-1"
                placement="bottom-end"
                addMenuClasses="dropdown-volume"
                addTogglerClasses="custom-toggle-volume"
                :caret="false">
                <template #toggler-content>
                  <i class="fa" :class="generateIconVolume(item.volume)"
                     style="cursor: pointer;font-size: 16px!important;"></i>
                  <span class="ml-2">{{ item.volume }}
                    </span>
                </template>
                <CDropdownItem>
                  <range-slider class="slider override" min="0" max="100" step="5" v-model="item.volume"
                                @change="changeVolume(item.id, item.volume, false)">
                  </range-slider>
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>
          <template #updateDate="{item}">
            <td>{{ $helper.formatDate(item.updateDate) }}</td>
          </template>
          <template #activeStatus="{item}">
            <td>
             <span class="badge badge-light" v-if="item.activeStatus == 1" :key="item.activeStatus"
                   v-c-tooltip="'Xem nội dung'"
                   @click.prevent="viewSchedulePlaying(item)">
                <i class="fa fa-play-circle-o speaker " style="color:green"></i>
                <span v-for="speaker in item.numberSpeakers">
                   <i :key="speaker.id" class="fa ml-2 speaker"
                      :class="speaker.running ? 'fa-volume-up' : 'fa-volume-off'"
                      :style="speaker.running ? 'color:green' : ''"></i>
                </span>
              </span>
              <span class="badge badge-light" v-if="item.activeStatus == 0">
                <i class="fa fa-stop-circle-o speaker"></i>
                 <span v-for="speaker in item.numberSpeakers">
                  <i class="fa fa-volume-off ml-2 speaker" :key="speaker.id"></i>
                </span>
              </span>
            </td>
          </template>
          <template #connectStatus="{item}">
            <td>
              <div style="display: inline-flex;width: 100%;height: 100%; align-items: center;">
                <i v-if="$hasAuthor('ROLE_ADMIN')" v-c-tooltip.hover="'Nhiệt độ: ' + `${parseInt(item.temperature)}℃`"
                   :key="item.temperature"
                   style="font-size: 22px;font-weight: 500;"
                   :style="item.temperature < 70 ? 'color:black;' : 'color:red;'"
                   class="mr-2 fa"
                   :class="item.temperature < 70 ? 'fa-thermometer-quarter' : 'fa-thermometer-full'"></i>
                <template v-if="item.networkType === 1">
                  <i class="mr-2 fa fa-wifi" style="font-size: 22px;font-weight: 500;" :key="item.networkType"
                     v-c-tooltip.hover="'Mạng không dây'"></i>
                </template>
                <template v-else-if="item.networkType === 0">
                  <svg width="25px" height="25px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" class="mr-2"
                       v-c-tooltip.hover="'Mạng có dây'"
                       style="margin-top: -3px">
                    <g id="Layer_2">
                      <g id="invisible_box" data-name="invisible box">
                        <rect width="24" height="24" fill="none"/>
                      </g>
                      <g id="horoscope">
                        <g>
                          <path
                            d="M25.6,25.6,22.2,29,19,25.8l3.4-3.4a2,2,0,0,0-2.8-2.8L16.2,23l-1.3-1.3a1.9,1.9,0,0,0-2.8,0l-3,3a9.8,9.8,0,0,0-3,7,9.1,9.1,0,0,0,1.8,5.6L4.6,40.6a1.9,1.9,0,0,0,0,2.8,1.9,1.9,0,0,0,2.8,0l3.2-3.2a10.1,10.1,0,0,0,5.9,1.9,10.2,10.2,0,0,0,7.1-2.9l3-3a2,2,0,0,0,.6-1.4,1.7,1.7,0,0,0-.6-1.4L25,31.8l3.4-3.4a2,2,0,0,0-2.8-2.8Z"/>
                          <path
                            d="M43.4,4.6a1.9,1.9,0,0,0-2.8,0L37.2,8a10,10,0,0,0-13,.9l-3,3a2,2,0,0,0-.6,1.4,1.7,1.7,0,0,0,.6,1.4L32.9,26.4a1.9,1.9,0,0,0,2.8,0l3-2.9a9.9,9.9,0,0,0,2.9-7.1A10.4,10.4,0,0,0,40,10.9l3.4-3.5A1.9,1.9,0,0,0,43.4,4.6Z"/>
                        </g>
                      </g>
                    </g>
                  </svg>
                </template>
                <template v-else>
                  <i class="mr-2 fa fa-ban" style="font-size: 22px;font-weight: 500;" :key="item.networkType"
                     v-c-tooltip.hover="'Chưa xác định'"></i>
                </template>
                <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
                <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
              </div>
            </td>
          </template>
          <template #locationName="{item}">
            <td>
              <span class="badge "
                    :class="(item.locationName != null && item.locationName != '') ? 'badge-light' : 'badge-danger'">
                {{ (item.locationName != null && item.locationName != '') ? item.locationName : 'Chưa gán' }}</span>
            </td>
          </template>
          <template #version="{item}">
            <td>
              <span class="badge badge-light">
                {{ item.version }}
              </span>
            </td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <CDropdown
                color="p-1"
                placement="bottom-end"
                addTogglerClasses=""
                :caret="false">
                <template #toggler-content>
                  <i class="fa fa-list-ul" style="font-size: 15px!important;"></i>
                </template>
                <CDropdownItem class="group-btn-action">
                  <div class="action-btn-wrapper">
                    <CButton color="info" variant="outline"
                             v-c-tooltip.hover="{ content:'Dừng phát thanh'}" square
                             size="sm" @click="setupSelectOneAction('stop_broadcasting', item.id, item.code)">
                      <i class="fa fa-stop"/>
                    </CButton>
                    <CButton color="info" variant="outline"
                             v-c-tooltip.hover="{content:'Khởi động lại thiết bị'}" square
                             size="sm"
                             @click="restartDevice(item.id)">
                      <i class="fa fa-power-off"/>
                    </CButton>
                    <template v-if="$hasAuthor('ROLE_ADMIN')">
                      <CButton color="info" variant="outline"
                               v-c-tooltip.hover="{content:'Lấy LogFile'}" square
                               size="sm"
                               @click="getLogDevice(item.id)">
                        <i class="fa fa-history"/>
                      </CButton>
                      <CButton color="info"
                               variant="outline"
                               v-c-tooltip.hover="{content:'Kiểm tra nhiệt độ'}" square
                               size="sm" @click="setupSelectOneAction('check_temp', item.id, item.code)">
                        <i class="fa fa-thermometer-empty"/>
                      </CButton>
                      <CButton color="info" variant="outline"
                               v-if="item.locationCode"
                               v-c-tooltip.hover="{ content:'Thay đổi thiết bị'}" square
                               size="sm" @click="setupChangeDevice(item)">
                        <i class="fa fa-exchange"/>
                      </CButton>
                      <CButton color="info" variant="outline"
                               v-c-tooltip.hover="{content:'Ảnh đính kèm'}" square
                               size="sm" @click="setupAttachImage(item)">
                        <i class="fa fa-image"/>
                      </CButton>
                      <CButton color="info"
                               variant="outline"
                               v-c-tooltip.hover="{ content:'Cấu hình thiết bị'}" square
                               size="sm" @click="setupConfigInformation(item)">
                        <i class="fa fa-cogs"/>
                      </CButton>
                      <CButton color="info"
                               variant="outline"
                               v-c-tooltip.hover="{ content:'Cấu hình xác thực'}" square
                               size="sm" @click="setupConfigAuthentication(item)">
                        <i class="fa fa-lock"/>
                      </CButton>
                      <CButton color="info" variant="outline"
                               v-c-tooltip.hover="{content:'Cập nhật phần mềm'}" square
                               size="sm" @click="setupSelectOneAction('update_app', item.id, item.code)">
                        <i class="fa fa-download"/>
                      </CButton>
                      <CButton color="info" variant="outline"
                               v-c-tooltip.hover="{content:'AT Command'}" square
                               size="sm" @click="setupATCommand(item)">
                        <i class="fa fa-comment"/>
                      </CButton>
                      <CButton color="info" variant="outline"
                               v-c-tooltip.hover="{content:'Kiểm tra âm thanh thiết bị'}" square size="sm"
                               @click="setupSelectOneAction('check_sound_speaker', item.id, item.code)">
                        <i class="fa fa-volume-up"></i>
                      </CButton>
                      <CButton color="info" variant="outline" square size="sm"
                               v-c-tooltip.hover="{content:'Xóa'}"
                               @click="setupSelectOneAction('delete_one', item.id, item.code)">
                        <CIcon name="cil-trash"/>
                      </CButton>
                    </template>
                  </div>
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <BaseModal title="Thay đổi âm lượng các thiết bị" :isFooter="false"
               :show.sync="isShowModalChangeVolumeMultipleDevice"
               :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
                    <span style="display: flex;justify-content: center; font-weight: 500;font-size: 20px;">
                      {{ volumeChangeMultipleDevice }}</span>
          <range-slider class="slider" min="0" max="100" step="5" v-model="volumeChangeMultipleDevice"
                        style="width: 100%;max-width: unset"
                        @change="changeVolume(null, volumeChangeMultipleDevice, true)">
          </range-slider>
        </CCol>
      </CRow>
    </BaseModal>

    <CModal v-if="modelShowSchedulePlaying.isShow"
            :title="'Nội dung đang phát: ' + modelShowSchedulePlaying.selectedDevice"
            :show.sync="modelShowSchedulePlaying.isShow" :closeOnBackdrop="false">
      <CRow class="content-fade-in" v-if="modelShowSchedulePlaying.details != null">
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Người tạo lịch: </span>{{
              modelShowSchedulePlaying.details.createUserName
            }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Địa bàn tạo: </span>{{
              modelShowSchedulePlaying.details.locationName
            }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Tên tệp tin: </span>{{
              modelShowSchedulePlaying.details.title
            }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Ngày tạo: </span>{{
              $helper.formatDateDDMMYYYYHHMM(modelShowSchedulePlaying.details.createDate)
            }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2">
          <label><span style="font-weight: bold">Bắt đầu từ: </span>{{
              modelShowSchedulePlaying.details.mode == 3 ? $helper.formatDate(modelShowSchedulePlaying.details.fromDate) : $helper.formatDate(modelShowSchedulePlaying.details.startTime)
            }}</label>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2" v-if="modelShowSchedulePlaying.details.mode != 3">
          <label><span style="font-weight: bold">Kết thúc lúc: </span>
            {{ $helper.formatDate(modelShowSchedulePlaying.details.endTime) }}
          </label>
          <div class="mt-2">
            <label><span style="font-weight: bold">Nội dung: </span>
              <span v-c-tooltip.hover="'Ấn để xem tệp'" @click="previewFile()"
                    class="previewFile">Ấn để xem tệp</span>
            </label>
          </div>
        </CCol>
        <CCol xs="12" sm="12" lg="12" xl="12" class="mb-2" v-if="modelShowSchedulePlaying.details.mode == 3">
          <label><span style="font-weight: bold">Trực tiếp: </span> <span class="blink"> Live</span></label>
        </CCol>
      </CRow>
      <CRow class="content-fade-in" v-else>
        <CCol>
          Không có nội dung nào đang phát!
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="modelShowSchedulePlaying.isShow = false"><i
          class="fa fa-times"></i> Đóng
        </button>
      </template>
    </CModal>

    <CModal title="Cấu hình thông tin cho thiết bị" :show.sync="isShowModalConfigInformation" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSetInformationDevice.locationLevelSelect.options"
                      :data="dataSetInformationDevice.locationLevelSelect.data"
                      ref="dataSetLocationLocationLevelSelect"></BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSetInformationDevice.locationCodeSelect.options"
                      :data="dataSetInformationDevice.locationCodeSelect.data"
                      ref="dataSetLocationLocationCodeSelect"></BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput
            :options="dataSetInformationDevice.longitudeInput.options"
            :data="dataSetInformationDevice.longitudeInput.data"
          />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput
            :options="dataSetInformationDevice.latitudeInput.options"
            :data="dataSetInformationDevice.latitudeInput.data"
          />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12" v-if="dataSetInformationDevice.type == 0">
          <div class="form-group">
            <label>{{ dataSetInformationDevice.speakerConf.options.label }}&nbsp;<span class="required">*</span></label>
            <div class="mt-1">
              <template v-for="(speaker, index) in dataSetInformationDevice.speakerConf.data.model">
                <CInputCheckbox custom @update:checked="checkBoxSpeakerConf($event, index)" :checked="speaker"
                                :inline="true"/>
              </template>
              <div class="valid-error"
                   v-show="!(dataSetInformationDevice.speakerConf.data.validator ? dataSetInformationDevice.speakerConf.data.validator.isValid : true)">
                {{
                  dataSetInformationDevice.speakerConf.data.validator ?
                    dataSetInformationDevice.speakerConf.data.validator.errorMessage : ""
                }}
              </div>
            </div>
          </div>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseTextArea :options="dataSetInformationDevice.descriptionInput.options"
                        :data="dataSetInformationDevice.descriptionInput.data"
                        v-model="dataSetInformationDevice.descriptionInput.data.model"/>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalConfigInformation = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitConfigInformation()"><i class="fa fa-check"></i> Cấu
          hình
        </button>
      </template>
    </CModal>
    <CModal v-if="isShowModalConfigAuthentication" title="Cấu hình thông tin xác thực"
            :show.sync="isShowModalConfigAuthentication" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <span class="required font-weight-bold">Chú ý: Thay đổi thông tin này cần người nắm được nghiệp vụ về hệ thống. Nếu không vui lòng không thực hiện
          thao tác này!</span>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseSelect :options="dataSubmitConfigAuthentication.authenServerSelect.options"
                      :data="dataSubmitConfigAuthentication.authenServerSelect.data"
                      ref="authenServerSelect"></BaseSelect>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <div class="form-group">
            <label>Stun Server</label>
            <div>
              <template v-for="each in dataConfigAuthentication.stunsServer">
                <span class="badge badge-light mr-1">{{ each }}</span>
              </template>
            </div>
          </div>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <div class="form-group">
            <label>Turn Server</label>
            <div>
              <template v-for="each in dataConfigAuthentication.turnsServer">
                <span class="badge badge-light mr-1"> {{ each.server }} - {{ each.user }}/{{ each.cred }}</span>
              </template>
            </div>
          </div>
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <div class="form-group">
            <label>Bật/Tắt Gửi LOG</label>
            <div>
              <CInputCheckbox custom :checked="dataConfigAuthentication.enablePutLog"
                              @update:checked="updateStateEnableLog($event)"/>
            </div>
          </div>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalConfigAuthentication = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitConfigAuthentication()"><i class="fa fa-check"></i>
          Cấu hình
        </button>
      </template>
    </CModal>

    <BaseModal v-if="isShowModalATCommand" :title="`AT Command: ${showATCmdModel.phoneNumber} - ${showATCmdModel.code}`"
               :isFooter="false"
               :size="'lg'"
               :show.sync="isShowModalATCommand"
               :closeOnBackdrop="false" id="12">
      <BaseFormATCommand :phoneNumber="showATCmdModel.phoneNumber"></BaseFormATCommand>
    </BaseModal>

    <CModal v-if="isShowModalExchangeDevice" :size="'xl'" :title="'Thay đổi thiết bị: ' + dataExchangeDevice.code"
            :show.sync="isShowModalExchangeDevice"
            :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <DeviceFreeForExchange @device:selected="deviceExchangeSelected($event)"></DeviceFreeForExchange>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalExchangeDevice = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button :disabled="dataExchangeDevice.id == '' || dataExchangeDevice.idExchange == ''" type="button"
                class="btn btn-primary" @click="submitExchangeDevice()">
          <i class="fa fa-check"></i> Thay đổi
        </button>
      </template>
    </CModal>

    <CModal title="Ảnh đính kèm" :size="'xl'" :show.sync="isShowModalAttachImage" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <template v-if="dataAttachImage.images.length > 0">
          <template v-for="(image, index) in dataAttachImage.images">
            <CCol sm="12" md="12" xl="3" xs="12" class="mb-3">
              <div>
                <img class="attachImage" :src="image" alt="" @click="showDetailImage(image)"/>
                <i class="fa fa-close editAttachImage"
                   v-c-tooltip.hover="'Xóa'" @click="removeAttachImage(image, index)"></i>
              </div>
            </CCol>
          </template>
        </template>
        <CCol sm="12" md="3" xl="3" xs="12" v-if="dataAttachImage.images.length < 4">
          <label class="label">
            <i class="fa fa-file"></i>
            <span class="title">Thêm Ảnh</span>
            <input type="file" accept=".jpg, .jpeg, .png" multiple @change="selectFile($event)"/>
          </label>
        </CCol>
        <div class="lightbox" v-if="showDetailUrl != ''" @click="showDetailUrl = ''">
          <img :src="showDetailUrl" alt="" class="content-fade-in">
        </div>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModalAttachImage = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitAttachImage()"><i class="fa fa-check"></i> Cập
          nhật
        </button>
      </template>
    </CModal>

    <BaseFormPreview v-if="modelShowSchedulePlaying.isShowModalPreview"
                     :title="modelShowSchedulePlaying.details.title"
                     :url="modelShowSchedulePlaying.details.url"
                     @close-modal="modelShowSchedulePlaying.isShowModalPreview = false"></BaseFormPreview>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import {TypeActionFileList} from '../../constant';
import {DatePicker} from "v-calendar";
import BaseModal from "@/views/base/BaseModal";
import DeviceFreeForExchange from "@/views/base/DeviceFreeForExchange";
import BaseFormATCommand from "@/views/base/BaseFormATCommand";
import BaseFormPreview from "@/views/base/BaseFormPreview";

export default {
  name: "DeviceList",
  components: {
    BaseFormPreview,
    BaseFormATCommand,
    DeviceFreeForExchange,
    BaseModal,
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/devices/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {id: that.actionData.model.deviceSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa thiết bị " + that.actionData.model.deviceSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("stop_broadcasting", {
      url: "/devices/stop_broadcasting",
      titlePopup: function () {
        return that.$helper.setupTitleAction("dừng phát thanh", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isShowWarningContent: true,
      warningContentPopup: function () {
        return '<span style="color: red; font-weight: bold">(Dừng phát thanh trên thiết bị có thể làm gián đoạn bản tin được đặt từ cấp trên, bao gồm cả bản tin thường và bản tin khẩn cấp, vui lòng kiểm tra lịch phát trước khi dừng phát thanh trên thiết bị. Người dùng dừng phát thanh sẽ chịu hoàn toàn trách nhiệm cho thao tác này.)</span><br/>'
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {id: that.actionData.model.deviceSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Đã gửi lệnh dừng phát thanh thiết bị " + that.actionData.model.deviceSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("update_app", {
      url: "/devices/update-app",
      titlePopup: function () {
        return that.$helper.setupTitleAction("cập nhật phần mềm", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {id: that.actionData.model.deviceSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Đã gửi lệnh cập nhật phần mềm " + that.actionData.model.deviceSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("check_sound_speaker", {
      url: "/devices/check-sound-speaker",
      titlePopup: function () {
        return that.$helper.setupTitleAction("kiểm tra âm thanh", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {id: that.actionData.model.deviceSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Đã gửi lệnh kiểm tra âm thanh " + that.actionData.model.deviceSelectedName + " thành công"});
        // that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("check_temp", {
      url: "/devices/check-temp",
      titlePopup: function () {
        return that.$helper.setupTitleAction("kiểm tra nhiệt độ", "thiết bị", that.actionData.model.deviceSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {id: that.actionData.model.deviceSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Đã gửi lệnh kiểm tra nhiệt độ " + that.actionData.model.deviceSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("action_list", {
      url: "/devices/actionList",
      titlePopup: function () {
        switch (that.actionData.model.type) {
          case TypeActionFileList.DELETE_LIST: {
            return that.$helper.setupTitleAction("xóa", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.RESTART_LIST: {
            return that.$helper.setupTitleAction("khởi động lại", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.UPDATE_APP_LIST: {
            return that.$helper.setupTitleAction("cập nhật phần mềm", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.STOP_BROADCASTING: {
            return that.$helper.setupTitleAction("dừng phát thanh", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.CHECK_TEMPERATURE: {
            return that.$helper.setupTitleAction("kiểm tra nhiệt độ", "các thiết bị", "đã chọn");
          }
          case TypeActionFileList.GET_STATUS: {
            return that.$helper.setupTitleAction("đồng bộ lại dữ liệu", "các thiết bị", "đã chọn");
          }
        }
      },
      isShowWarningContent: true,
      warningContentPopup: function () {
        switch (that.actionData.model.type) {
          case TypeActionFileList.STOP_BROADCASTING: {
            return '<span style="color: red; font-weight: bold">(Dừng phát thanh trên thiết bị có thể làm gián đoạn bản tin được đặt từ cấp trên, bao gồm cả bản tin thường và bản tin khẩn cấp, vui lòng kiểm tra lịch phát trước khi dừng phát thanh trên thiết bị. Người dùng dừng phát thanh sẽ chịu hoàn toàn trách nhiệm cho thao tác này.)</span><br/>';
          }
        }
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          ids: that.actionData.model.listDeviceSelectedId,
          type: that.actionData.model.type
        };
      },
      successCallback: function () {
        that.actionData.model.listDeviceSelectedId = [];
        switch (that.actionData.model.type) {
          case TypeActionFileList.DELETE_LIST: {
            that.showSuccessMsg({message: "Xóa các thiết bị thành công"});
            break;
          }
          case TypeActionFileList.RESTART_LIST: {
            that.showSuccessMsg({message: "Thực hiện thao tác khởi động lại các thiết bị thành công"});
            break;
          }
          case TypeActionFileList.UPDATE_APP_LIST: {
            that.showSuccessMsg({message: "Thực hiện thao tác cập nhật phần mềm các thiết bị thành công"});
            break;
          }
          case TypeActionFileList.CHECK_TEMPERATURE: {
            that.showSuccessMsg({message: "Thực hiện thao tác kiểm tra nhiệt độ các thiết bị thành công"});
            break;
          }
          case TypeActionFileList.GET_STATUS: {
            that.showSuccessMsg({message: "Thực hiện thao tác đồng bộ lại dữ liệu các thiết bị thành công"});
            break;
          }
          case TypeActionFileList.STOP_BROADCASTING: {
            that.showSuccessMsg({message: "Dừng phát thanh các thiết bị thành công"});
            break;
          }
        }
        that.loadDataMainTable();
      },
    });

    return {
      loading: {value: false},
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      typeActionList: TypeActionFileList,
      isShowModalChangeVolumeMultipleDevice: false,
      modelShowSchedulePlaying: {
        isShow: false,
        isShowModalPreview: false,
        selectedDevice: null,
        details: {}
      },
      volumeChangeMultipleDevice: 50,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          deviceSelectedId: null,
          deviceSelectedName: null,
          status: null,
          listDeviceSelectedId: [],
          type: null
        }
      },
      codeInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "code",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      descriptionInput: {
        options: {
          placeholder: "Mô tả địa chỉ",
          label: 'Mô tả địa chỉ'
        },
        data: {
          name: "description",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },

      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: true,
          disabled: true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },

      connectStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái kết nối',
        },
        data: {
          name: "connectStatus",
          items: [
            {key: "-1", value: "Tất cả"},
            {key: "1", value: "Kết nối"},
            {key: "0", value: "Mất kết nối"},
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      activeStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái hoạt động',
        },
        data: {
          name: "activeStatus",
          items: [
            {key: "-1", value: "Tất cả"},
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Không hoạt động"},
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },

      locationStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái địa bàn',
        },
        data: {
          name: "isDevice",
          items: [
            {key: "-1", value: "Tất cả"},
            {key: "0", value: "Đã gán"},
            {key: "1", value: "Chưa gán"},
          ],
          model: "-1",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },

      isShowModalAttachImage: false,
      isShowModalConfigInformation: false,
      isShowModalConfigAuthentication: false,
      dataConfigAuthentication: {},
      dataSubmitConfigAuthentication: {
        id: null,
        authenServerSelect: {
          options: {
            filter: false,
            label: 'Authentication Server',
            'keyField': 'code',
            'valueField': 'description',
            selectAllText: 'Mặc định'
          },
          data: {
            name: "",
            items: [],
            model: "",
          }
        },
        enablePutLog: null
      },
      isShowModalATCommand: false,
      isShowModalExchangeDevice: false,
      showDetailUrl: '',
      showATCmdModel: {
        phoneNumber: '',
        code: '',
      },
      dataAttachImage: {
        id: null,
        oldImages: [],
        images: [],
        imagesRemove: []
      },
      dataSetInformationDevice: {
        id: null,
        type: null,
        locationLevel: "",
        locationCode: "",
        descriptionInput: {
          options: {
            label: "Mô tả thiết bị",
            placeholder: "Mô tả thiết bị",
            maxlength: 2000,
            rows: 5
          },
          data: {
            name: "description",
            model: "",
          }
        },
        speakerConf: {
          options: {
            label: "Vị trí loa",
          },
          data: {
            name: "speakerConf",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSetInformationDevice.speakerConf.data.model;
                if (that.dataSetInformationDevice.type == 0 && value.filter(each => each === true).length == 0) {
                  this.isValid = false;
                  this.errorMessage = "Tối thiểu phải có 1 vị trí loa được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        locationLevelSelect: {
          options: {
            filter: false,
            label: 'Cấp địa phương',
            'keyField': 'key',
            'valueField': 'value',
          },
          data: {
            name: "locationLevel",
            items: [
              {key: "0", value: "Cấp Tỉnh/Thành phố"},
            ],
            model: null,
          },
        },
        locationCodeSelect: {
          options: {
            filter: true,
            label: "Địa phương",
            selectAllText: "Chọn địa phương",
            'keyField': 'key',
            'valueField': 'value',
            lazyLoad: true
          },
          data: {
            name: "locationCode",
            items: [],
            model: null,
            source: {
              url: '/common/findAllLocationByLevel',
              dataSubmit: function () {
                return {
                  level: that.dataSetInformationDevice.locationLevelSelect.data.model
                }
              },
              isJsonContentType: false,
              response: function (dataResponse) {
                that.dataSetInformationDevice.locationCodeSelect.data.items = dataResponse.data;
                that.isShowModalConfigInformation = true;
                setTimeout(() => {
                  that.dataSetInformationDevice.locationCodeSelect.data.model = that.dataSetInformationDevice.locationCode;
                }, 100)
              }
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSetInformationDevice.locationCodeSelect.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Địa phương không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        longitudeInput: {
          options: {
            placeholder: "Kinh độ",
            label: 'Kinh độ'
          },
          data: {
            name: "longitude",
            model: ""
          }
        },
        latitudeInput: {
          options: {
            placeholder: "Vĩ độ",
            label: 'Vĩ độ'
          },
          data: {
            name: "latitude",
            model: ""
          }
        },
      },
      dataExchangeDevice: {
        id: '',
        code: '',
        idExchange: ''
      },

      mainTable: {
        options: {
          slots: ["checkbox", "index", "code", "volume", "version", "phoneNumber", "activeStatus", "temperature",
            "connectStatus", "updateDate", "locationName", "action"],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          itemsPerPageSelect: {label: ' ', values: [15, 20, 50], external: true},
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
          lazyLoad: false
        },
        dataSource: {
          url: "/devices/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            that.actionData.model.listDeviceSelectedId = [];
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    updateStateEnableLog(value) {
      this.dataSubmitConfigAuthentication.enablePutLog = value;
    },
    previewFile: function () {
      this.modelShowSchedulePlaying.isShowModalPreview = true;
    },
    viewSchedulePlaying(item) {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/findSchedulePlayingById",
        dataSubmit() {
          return {
            deviceId: item.id
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.modelShowSchedulePlaying.details = response.data.data;
            that.modelShowSchedulePlaying.selectedDevice = item.code;
            that.modelShowSchedulePlaying.isShow = true;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    copyPhoneNumber(phoneNumber) {
      navigator.clipboard.writeText(phoneNumber);
    },
    getInformationPhone(item) {
      let response = `<div class="text-left"><div><b>Nhà mạng:</b> ${item.networkProvider}</div>
                       <div><b>IMEI:</b> ${item.phoneImei}</div>`;
      // if (item.phoneDataCapacity != null) {
      //   response += `<div><b>Dung lượng:</b> ${item.phoneDataCapacity}</div>`;
      // }
      // if (item.phoneDateActive) {
      //   response += `<div><b>Data có hiệu lực:</b> ${this.$helper.formatDateDDMMYYYY(item.phoneDateActive)}</div>`;
      // }
      if (item.phoneDateExpired) {
        response += `<div><b>Data hết hiệu lực:</b> ${this.$helper.formatDateDDMMYYYY(item.phoneDateExpired)}</div>`;
      }
      if (item.dateWarranty) {
        response += ` <div> <b>Thời hạn bảo hành:</b> ${this.$helper.formatDateDDMMYYYY(item.dateWarranty)} </div>`;
      }
      if (item.phoneCcId) {
        response += ` <div> <b>ICCID:</b> ${item.phoneCcId} </div>`;
      }
      response += '</div>';
      return response;
    },
    generatePhoneNetWork(item) {
      var res = '';
      var phoneNetwork = item.phoneNetworkMode.toString();
      if (item && phoneNetwork) {
        // var network = phoneNetwork.split(".");
        switch (phoneNetwork) {
          case "0": {
            res = 'NO SERVICE';
            break;
          }
          case "1": {
            res = 'GSM';
            break;
          }
          case "2": {
            res = 'G';
            break;
          }
          case "3": {
            res = 'E';
            break;
          }
          case "4": {
            res = '3G';
            break;
          }
          case "5": {
            res = '3G+';
            break;
          }
          case "6": {
            res = 'H';
            break;
          }
          case "7": {
            res = 'H+';
            break;
          }
          case "8": {
            res = 'LTE';
            break;
          }
          // case "9": {
          //   break;
          // }
          // case "10": {
          //   break;
          // }
          // case "11": {
          //   break;
          // }
          // case "12": {
          //   break;
          // }
          // case "13": {
          //   break;
          // }
          // case "14": {
          //   break;
          // }
          // case "15": {
          //   break;
          // }
          // case "16": {
          //   break;
          // }
          // case "23": {
          //   break;
          // }
          // case "24": {
          //   break;
          // }
        }
      }
      return res;
    },
    setupChangeDevice(item) {
      this.dataExchangeDevice.id = item.id;
      this.dataExchangeDevice.code = item.code;
      this.isShowModalExchangeDevice = true;
    },
    deviceExchangeSelected(item) {
      this.dataExchangeDevice.idExchange = item.id;
    },
    closeModalExchange(value) {
      this.isShowModalExchangeDevice = value;
    },
    submitExchangeDevice() {
      if (this.dataExchangeDevice.id == '' || this.dataExchangeDevice.idExchange == '') {
        return;
      }
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/exchangeDevice",
        dataSubmit: function () {
          return {
            id: that.dataExchangeDevice.id,
            idExchange: that.dataExchangeDevice.idExchange,
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({message: "Thay đổi thiết bị thành công"});
            that.loadDataMainTable();
            that.isShowModalExchangeDevice = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupAttachImage(item) {
      this.isShowModalAttachImage = true;
      this.dataAttachImage.id = item.id;
      this.dataAttachImage.images = [];
      this.dataAttachImage.oldImages = [];
      item.attachImages.map(each => {
        this.dataAttachImage.oldImages.push(each)
        this.dataAttachImage.images.push(each);
      })
      this.dataAttachImage.imagesRemove = [];
    },
    removeAttachImage(image, index) {
      this.dataAttachImage.images.splice(index, 1);
      if (this.dataAttachImage.oldImages.includes(image)) {
        this.dataAttachImage.imagesRemove.push(image);
      }
    },
    async selectFile(event) {
      let that = this;
      if (event.target.files.length > 0) {
        // this.loading.value = true;
        if (this.dataAttachImage.images.length < 4) {
          Promise.all(
            (function* () {
              let _that = that;
              for (let file of event.target.files) {
                yield new Promise(resolve => {
                  let reader = new FileReader();
                  reader.onload = () => {
                    let data = {
                      file: file,
                      // urlBlob: _that.convertBlob(reader.result),
                      base64: reader.result,
                    }
                    resolve(data)
                  };
                  reader.readAsDataURL(file);
                })
              }
            })())
            .then(texts => {
              texts.map(each => {
                if (this.validateFile(each.file)) {
                  this.dataAttachImage.images.push(each.base64)
                }
              })
              // setTimeout(() => {
              // that.loading.value = false
              // }, 300)
            }).catch(error => {
            // that.loading.value = false;
          });
        }
      }
    },
    validateFile(file) {
      if (this.dataAttachImage.images.length >= 4) {
        return false;
      } else {
        if (file && file.type !== 'image/jpeg' && file.type !== 'image/png') {
          return false;
        }
        return true;
      }
    },
    showDetailImage(image) {
      this.showDetailUrl = image;
    },
    submitAttachImage() {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/attach_images",
        dataSubmit: function () {
          return {
            id: that.dataAttachImage.id,
            images: that.dataAttachImage.images,
            imagesRemove: that.dataAttachImage.imagesRemove,
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({message: "Cập nhật ảnh đính kèm thành công"});
            that.loadDataMainTable();
            that.isShowModalAttachImage = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    convertDataURIToBinary(dataURI) {
      let BASE64_MARKER = ';base64,';
      let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      let base64 = dataURI.substring(base64Index);
      let raw = window.atob(base64);
      let rawLength = raw.length;
      let array = new Uint8Array(new ArrayBuffer(rawLength));
      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    },
    convertBlob(data) {
      let binary = this.convertDataURIToBinary(data);
      let blob = new Blob([binary], {type: 'image/png'});
      return URL.createObjectURL(blob);
    },
    loadDataMainTable: function (isUpdateFilter, isLoading) {
      this.$refs.mainTable.loadData(isUpdateFilter, isLoading);
    },
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listDeviceSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listDeviceSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listDeviceSelectedId = [];
      }
    },
    rowClickTable(value) {
      let targetClick = value.event.target;
      if (value.column === 'volume' && ($(targetClick).is("button") || $(targetClick).is("span") || $(targetClick).is("i"))) {
        return;
      } else if (value.column === 'action' && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (value.column === 'activeStatus') {
        return;
      }
      if (value.column === 'phoneNumber') {
        return;
      }
      if (value && value.item && value.item.id) {
        if (this.actionData.model.listDeviceSelectedId.includes(value.item.id)) {
          const index = this.actionData.model.listDeviceSelectedId.indexOf(value.item.id)
          if (index > -1) { // only splice array when item is found
            this.actionData.model.listDeviceSelectedId.splice(index, 1); // 2nd parameter means remove one item only
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          this.actionData.model.listDeviceSelectedId.push(value.item.id);
        }
      }
    },
    submitCheckTemperature() {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/checkTemperature",
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({message: "Thực hiện thao tác kiểm tra nhiệt độ thành công"});
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    generateIconVolume(volume) {
      if (volume == 0) {
        return 'fa-volume-off'
      } else if (volume < 50) {
        return 'fa-volume-down'
      } else {
        return 'fa-volume-up'
      }
    },
    setupSelectOneAction: function (actionTypeKey, deviceId, deviceName, status, type) {
      let actionData = this.actionData.model;
      actionData.deviceSelectedId = deviceId || null;
      actionData.deviceSelectedName = deviceName || null;
      actionData.status = status || null;
      actionData.type = type || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    setupConfigInformation(item) {
      let that = this;
      // this.dataSetInformationDevice.locationLevelSelect.data.model = null;
      // this.dataSetInformationDevice.locationLevelSelect.data.items = item.type == 0 ? [
      //   {key: "0", value: "Cấp Tỉnh"},
      //   {key: "1", value: "Cấp Huyện"},
      //   {key: "2", value: "Cấp Xã"},
      // ] : [
      //   {key: "1", value: "Cấp Huyện"},
      // ]
      this.dataSetInformationDevice.locationLevelSelect.data.model = 0;
      this.dataSetInformationDevice.id = item.id;
      this.dataSetInformationDevice.type = 0;
      this.dataSetInformationDevice.locationCode = item.locationCode;
      this.dataSetInformationDevice.longitudeInput.data.model = item.longitude;
      this.dataSetInformationDevice.latitudeInput.data.model = item.latitude;
      this.dataSetInformationDevice.locationCodeSelect.data.validator.isValid = true;
      this.dataSetInformationDevice.descriptionInput.data.model = item.description;
      this.dataSetInformationDevice.speakerConf.data.model = item.speakerConf;
      setTimeout(() => {
 
          that.dataSetInformationDevice.locationLevelSelect.data.model = item.locationLevel | 0;
       
      })
    },
    setupConfigAuthentication(item) {
      this.dataSubmitConfigAuthentication.id = item.id;
      this.dataSubmitConfigAuthentication.enablePutLog = item.enableLog;
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/constant/getListKeyAuthenticationDevice",
        dataSubmit() {
          return {}
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.dataConfigAuthentication = response.data.data.response;
            that.dataConfigAuthentication.enablePutLog = item.enableLog;
            that.dataSubmitConfigAuthentication.authenServerSelect.data.items = response.data.data.response.authensServer;
            that.isShowModalConfigAuthentication = true;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitConfigAuthentication() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/devices/configAuthentication",
        dataSubmit() {
          return {
            id: that.dataSubmitConfigAuthentication.id,
            enableLog: that.dataSubmitConfigAuthentication.enablePutLog,
            authenCode: that.dataSubmitConfigAuthentication.authenServerSelect.data.model,
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({message: "Xác nhận gửi cấu hình xác thực tới thiết bị thành công"});
            that.isShowModalConfigAuthentication = false;
            that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupATCommand(item) {
      this.isShowModalATCommand = true;
      this.showATCmdModel.code = item.code;
      this.showATCmdModel.phoneNumber = item.phoneNumber;
    },
    checkBoxSpeakerConf(value, index) {
      this.dataSetInformationDevice.speakerConf.data.model[index] = value;
    },
    submitConfigInformation() {
      let isValid = true;
      isValid &= this.dataSetInformationDevice.locationCodeSelect.data.validator.valid();
      isValid &= this.dataSetInformationDevice.speakerConf.data.validator.valid();
      if (!isValid) {
        return;
      }
      let that = this;
      this.$helper.loadDataSource({
        url: "/devices/configInformation",
        dataSubmit: function () {
          return {
            id: that.dataSetInformationDevice.id,
            locationCode: that.dataSetInformationDevice.locationCodeSelect.data.model,
            longitude: that.dataSetInformationDevice.longitudeInput.data.model,
            latitude: that.dataSetInformationDevice.latitudeInput.data.model,
            description: that.dataSetInformationDevice.descriptionInput.data.model,
            speakerConf: that.dataSetInformationDevice.speakerConf.data.model
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSetInformationDevice);
          } else {
            that.showSuccessMsg({message: "Cập nhật thông tin thiết bị thành công"});
            that.isShowModalConfigInformation = false;
            that.loadDataMainTable(false, true);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    changeVolume(id, _volume, isChangeAll) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/updateVolume",
        isJsonContentType: false,
        dataSubmit: function () {
          let dataReq = null;
          if (isChangeAll) {
            dataReq = {
              deviceId: '',
              volume: _volume,
              deviceIds: that.actionData.model.listDeviceSelectedId
            }
          } else {
            dataReq = {
              deviceId: id || '',
              volume: _volume,
              deviceIds: []
            }
          }
          return dataReq;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.isShowModalChangeVolumeMultipleDevice = false;
            that.showSuccessMsg({
              message: "Thực hiện thao tác thay đổi âm lượng thành công"
            });
            that.loading.value = false;
            if (isChangeAll) {
              that.loadDataMainTable(false, false);
              //   that.actionData.model.listDeviceSelectedId = [];
            }
            $('body').click();
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    restartDevice(id) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/restart",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thực hiện thao tác khởi động lại thiết bị thành công"
            });
            that.loadDataMainTable(false, false);
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    getLogDevice(id) {
      let that = this;
      this.loading.value = true;
      this.$helper.loadDataSource({
        url: "/devices/getLog",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            deviceId: id
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thực hiện thao tác lấy log thiết bị thành công"
            });
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  created: function () {
  },
  mounted() {
    if (this.$hasAuthor("ROLE_ADMIN")) {
      this.mainTable.options.fields = [
        {key: "checkbox", label: "#", sorter: false, filter: false},
        {key: "updateDate", label: "Cập nhật cuối", _style: "width:10%"},
        {key: "code", label: "Mã thiết bị"},
        {key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:12%;"},
        {key: "activeStatus", label: "Trạng thái hoạt động"},
        {key: "connectStatus", label: "Trạng thái kết nối"},
        {key: "volume", label: "Âm lượng", _style: "width:8%;"},
        {key: "description", label: "Mô tả địa chỉ", _style: "min-width:15%"},
        {key: "locationName", label: "Địa bàn"},
        {key: "version", label: "Version"},
        {key: "action", label: "Thao tác", sorter: false, filter: false},
      ]
    } else {
      this.mainTable.options.fields = [
        {key: "checkbox", label: "#", sorter: false, filter: false},
        {key: "updateDate", label: "Cập nhật cuối", _style: "width:10%"},
        {key: "code", label: "Mã thiết bị"},
        {key: "phoneNumber", label: "Số thuê bao/IP", _style: "width:12%;"},
        {key: "activeStatus", label: "Trạng thái hoạt động"},
        {key: "connectStatus", label: "Trạng thái kết nối"},
        {key: "volume", label: "Âm lượng", _style: "width:8%;"},
        {key: "description", label: "Mô tả địa chỉ", _style: "min-width:15%"},
        {key: "locationName", label: "Địa bàn"},
        {key: "action", label: "Thao tác", sorter: false, filter: false},
      ]
    }
  },
  watch: {
    "actionData.model.listDeviceSelectedId": function (newValue) {
      let that = this;
      if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
        that.$refs.mainTable.items.map(each => each._classes = 'active');
      } else {
        that.actionData.model.selectedAll = false;
        if (newValue.length == 0) {
          that.$refs.mainTable.items.map(each => each._classes = 'inactive');
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
    'dataSetInformationDevice.locationLevelSelect.data.model': function (value, old) {
      if (value) {
        this.$refs.dataSetLocationLocationCodeSelect.loadData();
      }
    },
    'isShowModalExchangeDevice': function (value) {
      if (!value) {
        this.dataExchangeDevice = {
          id: '',
          code: '',
          idExchange: ''
        }
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.speaker {
  font-size: 20px;
}

.previewFile {
  font-weight: 600;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.blink {
  animation: blink 1.3s infinite;
  border: 1px solid;
  border-radius: 15px;
  padding: 2px 10px;
  background: rgba(0, 128, 0, 0.56);
  color: white;
  font-weight: 600;
  font-size: 12px;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

#deviceList {

  .lightbox {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    padding-top: 30px;
    text-align: center;

    img {
      height: 95vh;
    }
  }

  .slider.override {
    width: 200px !important;;
    max-width: 200px !important;;
    //padding: 0 !important;
  }

  .range-slider-rail, .range-slider-fill {
    height: 6px !important;
  }

  .range-slider-fill {
    background-color: #0b98ff !important;
  }

  .range-slider-knob {
    width: 15px !important;
    height: 15px !important;
  }

  .range-slider {
    padding: unset !important;
  }

  .dropdown-volume {
    padding: unset;
    border-radius: 50px;
  }

  .dropdown-volume a:hover {
    background: none !important;
  }

  .custom-toggle-volume {
    min-width: 70px;
    display: inline-flex !important;
    justify-content: center;
  }

  .volume .dropdown {
    display: inline-flex !important;
  }

  .action-custom {
    height: 200px;
    overflow: auto;
  }

  .group-btn-action {
    height: 35px;
    justify-content: center;
  }

  .group-btn-action:hover {
    background: unset !important;
  }

  .attachImage {
    position: relative;
    width: 100%;
    border-radius: 15px;
    cursor: pointer;
    height: 500px;
    object-fit: cover;

    &:hover {
    }
  }

  .editAttachImage {
    cursor: pointer;
    position: absolute;
    border: 1px solid rgba(128, 128, 128, 0.52);
    color: #c51a1a;
    font-size: 18px;
    background: white;
    top: -10px;
    right: 0px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 100%;

    &:hover {
      background: red;
      color: white;
    }
  }

  $input-file-color: grey;
  $input-file-hover-color: black;

  input[type=file] {
    outline: 0;
    opacity: 0;
    pointer-events: none;
    user-select: none;
  }

  .label {
    width: 120px;
    //height: 100%;
    border: 2px dashed $input-file-color;
    border-radius: 5px;
    display: block;
    padding: 1.2em;
    transition: border 300ms ease;
    cursor: pointer;
    text-align: center;

    i {
      display: block;
      font-size: 42px;
      padding-bottom: 16px;
    }

    i, .title {
      color: $input-file-color;
      transition: 200ms color;
    }

    &:hover {
      border: 2px solid $input-file-hover-color;

      i, .title {
        color: $input-file-hover-color;
      }
    }
  }


  #bars {
    position: relative;
    width: 32px;
    height: 20px;
    display: inline-flex;

    .bar {
      position: absolute;
      bottom: 0;
      width: 4px;

      &:nth-child(1) {
        height: 6px;
        left: 0px;
      }

      &:nth-child(2) {
        height: 10px;
        left: 7px;
      }

      &:nth-child(3) {
        height: 14px;
        left: 14px;
      }

      &:nth-child(4) {
        height: 18px;
        left: 21px;
      }
    }
  }
}
</style>
